import Axios from 'axios';

const axios = Axios.create({
  baseURL: process.env.REACT_APP_CURRENCY_EXCHANGE_API_URL,
});

export const getRates = (from) => {
  return axios.get(`/currency/exchange?from=${from}`).then(response => response.data || {});
}
